import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoNotHireComponent } from './do-not-hire.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ExternalNotesModule } from '../external-notes/external-notes.module';
import { AiAssistantModule } from '../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [DoNotHireComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ExternalNotesModule,
    AiAssistantModule
  ],
  entryComponents: [DoNotHireComponent],
  exports: [DoNotHireComponent]
})
export class DoNotHireModule { }
